









































































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import { Order, OrderDimensions } from '@/interfaces/order.interface';


@Component({
  components: {

  }
})
export default class DocumentDatatable extends Vue {
  @Prop({default: []}) order!: Order;
  @Prop({default: []}) headers: string[];
  @Prop({default: []}) dataKeys: string[];
  @Prop({default: [
      {
        itemNo: '1',
        partNumber: '213456789',
        serialNumber: 'N/A',
        description: 'TOOLBOX, HAND TOOLS\n HS CODE 82059090 \nCOUNTRY OF ORIGIN: US',
        qty: '1',
        unit: 'EA',
        unitPrice: '690',
        amount: '690'
      },
      {
        itemNo: '2',
        partNumber: 'N/A',
        serialNumber: 'N/A',
        description: 'DOCUMENTS',
        qty: '1',
        unit: 'BOX',
        unitPrice: '0',
        amount: '0'
      }
    ]}) documentData!: any[];

  onInput(e: any, key: string, dataIndex: number) {
    if(e !== null) {
      const target= e.target as HTMLElement;
      this.documentData[dataIndex][key] = target.innerText;
    }
  }

  printDimensions() {
    if(this.order.dimensions) {
      const dimensions = this.order.dimensions.map((dimension: OrderDimensions) => {
        if (Object.keys(dimension).length === 0 && dimension.constructor === Object) { // if dimensions empty
          return ''
        }
        return `${dimension.quantity} x ${dimension.length}x${dimension.width}x${dimension.height} cm ${dimension.weight} kg`
      })
      return dimensions.join("\n");
    }
  }

  addRow() {
    let row = {} as {
      [key: string]: string
    }
    this.dataKeys.forEach((key: string) => {
      row[key] = '';
    });
    this.documentData.push(row)
  }

  popRow() {
    this.documentData.pop();
  }

  async mounted() {
  }

}
